import { Grid } from '@mui/material';
import { AuditDateTimeRangeFields } from '../../../../components/AuditDateTimeRangeFields';
import { MentionIdField } from '../../../../components/MentionIdField';
import { ScheduleMetadataFilterFields } from '../../ScheduleMetadataFilterFields';

/**
 * Filter form for mentions schedules listing.
 */
export function SchedulesListMentionsForm() {
  return (
    <div>
      <AuditDateTimeRangeFields />
      <Grid container spacing={2}>
        <Grid item xs={12} md={4} lg={3} xl={2}>
          <MentionIdField />
        </Grid>
        <ScheduleMetadataFilterFields />
      </Grid>
    </div>
  );
}
